import type { ContestEntryWorkFormValue } from "@/components/organisms/event/contestEntryWorkFormTypes";

export const CONTEST_ENTRY_WORK_TITLE_MAX_LENGTH = 100;
export const CONTEST_ENTRY_SYNOPSIS_MAX_LENGTH = 1000;

/**
 * Step2 の次へ進む条件と Step3 の表示条件を揃える。
 * ローカルインポートは未実装のため workSource が nola のときだけ完了とみなす。
 */
export function isContestEntryWorkFormComplete(
  form: ContestEntryWorkFormValue,
  options: { categoryRequired: boolean },
): boolean {
  if (options.categoryRequired && !form.categoryId) return false;
  if (form.workSource !== "nola") return false;

  const { workTitle, synopsis } = form;
  return (
    !!form.novelId &&
    workTitle.trim().length > 0 &&
    workTitle.length <= CONTEST_ENTRY_WORK_TITLE_MAX_LENGTH &&
    synopsis.trim().length > 0 &&
    synopsis.length <= CONTEST_ENTRY_SYNOPSIS_MAX_LENGTH
  );
}
